function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 254.3 254.3",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m249.628 53.216-.191-.127c-2.86-3.337-6.865-5.403-11.315-5.403H16.185c-4.545 0-8.581 2.193-11.473 5.594l-.064-.064c-6.198 6.897-6.198 18.084 0 24.981l111.207 123.221c6.198 6.929 16.241 6.929 22.438 0l.381-.667L249.628 78.197c6.229-6.897 6.229-18.084 0-24.981"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-triangle-down.svg";
export { SvgComponent as ReactComponent };